import { FLOWS, FLOW_VALUES } from './reservation-flow.constants';
import * as i0 from "@angular/core";
var ReservationFlowService = /** @class */ (function () {
    function ReservationFlowService() {
    }
    ReservationFlowService.prototype.setFlow = function (flowValue) {
        this.flow = flowValue && FLOW_VALUES[flowValue];
    };
    ReservationFlowService.prototype.getFlow = function () {
        return this.flow;
    };
    ReservationFlowService.prototype.isModFlow = function () {
        return !!this.flow;
    };
    ReservationFlowService.prototype.isModSailingFlow = function () {
        return this.flow && this.flow.id === FLOWS.sailing;
    };
    ReservationFlowService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReservationFlowService_Factory() { return new ReservationFlowService(); }, token: ReservationFlowService, providedIn: "root" });
    return ReservationFlowService;
}());
export { ReservationFlowService };
